import useMagicLink from "use-magic-link";

export default function useAuth() {
  return useMagicLink("pk_test_0A408BB8A12DA07A");
}
